export default [
  { key: 'path', name: 'Path', path: '/path' },
  { key: 'cms', name: 'CMS', path: '/cms' },
  { key: 'offer', name: 'Traffic', path: '/offer' },
  { key: 'report', name: 'Reports', path: '/reports' },
  { key: 'setting', name: 'Settings', path: '/settings' },
];
